export class Program {
  id: string;
  programName: string;
  programTypeId: string;
  shortDescription: string;
  programDescription: string;
  url?: string;
  content?: string;
  companyIds: string[];
  companiesPermissions: any[];
  lifeSubAreaIds: string[];
  active: boolean;
  programImage: string;
  programImageBase64: string;
  programImageExtension: string;
  programLogoImage: string;
  programLogoImageBase64: string;
  programLogoExtension: string;
  picturePath: string;
  inclusionDate: Date;
  programType: string;
  classificationGroupIds: string[];
  toCardiopathy: boolean;
  toDiabetes: boolean;
  toPregnant: boolean;
  range: number;
  lat: number;
  lon: number;
  location: string;
  canEdit = false;

  toBreastCancer = false;
  toCervicalCancer = false;
  toColonCancer = false;
  toProstateCancer = false;
  toLungCancer = false;
  toOtherTypesOfCancer = false;
  toCancers = false;
  toLungDisease = false;
  toHypertension = false;
  toCholesterol = false;
  toObesity = false;
  toDepression = false;
  toOsteoporosis = false;
  toChemicalDependency = false;
  toSmoker = false;
  toSleep = false;
  toStress = false;
  toSedentary = false;
  toFinances = false;
  toWoman = false;
  toMan = false;
  toDyslipidemia = false;
  toHeartDisease = false;
}

export class ProgramType {
  id: number;
  name: string;
}

export interface ProgramPageableResponse {
  programs: Program[];
  count: number;
}
